import { Outlet } from "react-router-dom";
import SidebarLayout from "../../components/common/layout/SidebarLayout";
import { projectMenus } from "../../components/layout/ProjectMenus";

const DesignLayout = () => {
  const { title, base, sections } = projectMenus.design;

  return (
    <SidebarLayout
      title={title}
      base={base}
      sections={sections}
    >
      <Outlet />
    </SidebarLayout>
  );
};

export default DesignLayout;
